import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useFetch from "../Hooks/useFetch";
import { membersURL } from "../Hooks/URL";
import { userContext } from "../Contexts/userContext";
import Teams from "../Templates/Home/Teams/Teams";
import Members from "../Templates/Home/Members/Members";

function MembersPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [searchData, setSearchData] = useState("");
  const [search, setSearch] = useState("");
  const [Open, setOpen] = useState(false);
  const [sortBy, setSortBy] = useState("name");
  const [sortOrder, setSortOrder] = useState(false);

  const [filters, setFilters] = useState({
    accountPaid: "",
    hasDiscount: "",
    discountPercentage: "",
    competitionType: "",
  });

  const getFilterQueryString = (filters) => {
    const queryParams = Object.entries(filters)
      .filter(([_, value]) => value !== "")
      .map(([key, value]) => {
        return `${key}=${value}`;
      })
      .filter((param) => param !== "")
      .join("&");
    return queryParams;
  };

  const [members, setMembers] = useState([]);
  const [membersNumber, setMembersNumber] = useState(0);
  const { data, loading, error } = useFetch(
    membersURL,
    page,
    rowsPerPage,
    search,
    null,
    false,
    `${sortBy ? `&sortBy=${sortBy}` : ""}${
      sortOrder ? `&sortDesc=${sortOrder}` : ""
    }${
      getFilterQueryString(filters) ? `&${getFilterQueryString(filters)}` : ""
    }`
  );

  useEffect(() => {
    if (!loading && !error && data) {
      setMembers(data.data?.data?.rows);
      setPageCount(data.data?.data?.numberOfPages);
      setMembersNumber(data.data?.data?.totalCount);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "members", data: "" });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSortChange = (event) => {
    setSortBy(event.target.value);
  };

  const handleSortOrderChange = (event) => {
    setSortOrder(event.target.value);
  };

  const handleFilterChange = (event) => {
    if (event.target.name === "categoryId") {
      setFilters({
        ...filters,
        [event.target.name]: event.target.value,
        ageGroupId: "",
      });
    } else {
      setFilters({
        ...filters,
        [event.target.name]: event.target.value,
      });
    }
  };

  return (
    <Members
      page={page}
      rowsPerPage={rowsPerPage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      searchData={searchData}
      search={search}
      setSearchData={setSearchData}
      setSearch={setSearch}
      members={members}
      navigate={navigate}
      handleChangePage={handleChangePage}
      Open={Open}
      setOpen={setOpen}
      loading={loading}
      data={data}
      error={error}
      pageCount={pageCount}
      setMembers={setMembers}
      membersNumber={membersNumber}
      setPage={setPage}
      sortBy={sortBy}
      sortOrder={sortOrder}
      handleSortChange={handleSortChange}
      handleSortOrderChange={handleSortOrderChange}
      filters={filters}
      handleFilterChange={handleFilterChange}
      getFilterQueryString={getFilterQueryString}
    />
  );
}

export default MembersPage;
